import RaciPropertiesProvider from './RaciPropertiesProvider'

export default {
  __init__: ['raciPropertiesProvider'],
  raciPropertiesProvider: ['type', RaciPropertiesProvider],
}
